import Vue from 'vue';
import { Message, MessageBox, Notification } from 'element-ui';
import { timestampToFormatTime, formatTimeToTimestamp ,multiplication} from '~/common/utils';
import { storage } from '~/common/utils/storage';
import { auth, baseAuth, ichubProjectList } from '~/common/utils/json';
import { deepAssign, funGetFileTypeIcon } from '~/common/utils';
import store from '~/store/index'
import {translateI18n} from '~/common/utils/i18n-helper'
let icUtils = {};
const axios = ['seo','content'].includes(process.env.PROJECT_NAME)? Vue.prototype.$_axios : Vue.prototype.$axios
function arrayContain(array, string) {
  return array.some(item => {
    return item === string;
  });
}


export default  {
  install: async (vue) => {
      store.dispatch('getCurrencyList')
      store.dispatch('getShippingFront')
  }

}

export function getHttpHeader() {
  let session = '';
  if (process.client) {
    session = storage.get('session_token') || storage.get('session_token', true) || '';
  }
  return session;
}
/**
 * 页面跳转URL前缀
 * @param prefix需要添加的前缀
 * @returns {string}返回前缀
 * 用例：urlPrefix('store')
 */
export function urlPrefix(prefix) {
  let url = '';
  if (process.client) {
    url = location.pathname.indexOf(prefix) == -1 ? '' : '/' + prefix;
  }
  return url;
}
//金额人民币化
export function getPriceCny(from, to, v) {
  return axios.$post("rest/store/general/v3/currencies/exchange", {
      from_currency_id: `${from}`,
      from_value: `${v}`,
      to_currency_id: `${to}`
    })
    .then(({ code, data }) => {
      if (code !== 200) return;
      return data;
    });
}
//金额小数位数
export function getDecimal(cid = '8') {
  let item = storage.get('currency').filter(currency => cid == currency.id)[0];
  const decimal = item && item.decimals ? item.decimals : 4;
  return decimal;
}
function arrToSpuHtml(arr, url, str) {
  let html = '';
  for (let i = 0, len = arr.length; i < len; i++) {
    if (i < 2) {
      html += `<a href="${url}${arr[i].id}">您被分配为${arr[i].name}的${str}代表</a>`;
    }
    if (len > 1 && i == 0) {
      html += '，';
    } else if (len > 2 && i == 2) {
      html += '...';
    }
  }
  return html;
}

//全局过滤器
const icFilters = {
  /**
   * 用于货币数据类型转换：前端显示千分位，保留4位小数
   * 例如：后台数据price：12345，前端展示：￥12,345.000000
   * @param money 后台原始数据
   * @param id 货币符号
   * @param decimal 保留小数位数，可缺省（默认4位）。
   * @returns {string} ￥12,345.000000
   * 使用方法：
   * // 双花括号中
   * {{ price | formatMoney(currency_id,4)}}
   *
   * // 在v-html 中
   * <span v-html=" price | formatMoney(currency_id,4)"></span>
   */
  formatMoney(money, id, decimal, isDcode, noSymbol,noThousands,remainNum) {//remainNum：保留几位小数,后面的直接舍弃，非四舍五入
    // noThousands  不需要千分位
    if (!money || !Number(money)) {
      return '--';
    }
    if (!id || id === '0') {
      id = '8';
    }
    let item = storage.get('currency')?storage.get('currency').filter(currency => id == currency.id)[0]:0;
    decimal = decimal > 0 && decimal <= 20 ? decimal : item?.decimals ? item.decimals : 4;
    money = money / Math.pow(10, decimal);
    money = parseFloat((money + '').replace(/[^\d\.-]/g, '')).toFixed(decimal) + '';
    let d = parseFloat(money) < 0 ? Math.ceil(money) : Math.floor(money);
    let y = remainNum ? money.split('.')[1]?.slice(0,remainNum) || Math.pow(10,remainNum).toString().slice(1) : money.split('.')[1] || '0000';
    return (isDcode ? item?.dcode || 'CNY' : !noSymbol ? item?.symbol || '¥' : '') + (noThousands ? d : d.toLocaleString('en-US')) + '.' + y;
  },
  /**
   *
   * @param {*} money 后台原始数据
   * @param {*} id 货币id
   * @returns {string} ￥12,345.0000
   */
  formatRoundMoney(money,id,noSymbol=false,decimalPlaces=2,fixedPlaces=4){
    if (!money || !Number(money)) {
      return '--';
    }
    if (!id || id === '0') {
      id = '8';
    }
    let item = storage.get('currency')?storage.get('currency').filter(currency => id == currency.id)[0]:0;
    const decimal=item?.decimals||4
    money = money / Math.pow(10, decimal);
    const symbol=noSymbol?'' : item?.symbol || '¥'
    const val=icFilters.roundToDecimalPlace(money,decimalPlaces,fixedPlaces)
    return symbol+val
  },
  /**
   *
   * @param {*} decimalPlaces 四舍五入到小数点后几位
   * @param {*} fixedPlaces 需要补0的位数
   * @returns {string} 12,345.2500
   */
  roundToDecimalPlace(money, decimalPlaces,fixedPlaces) {
    const factor = Math.pow(10, decimalPlaces);
    const num=Math.round(money * factor) / factor;
    return num.toFixed(fixedPlaces)
  },
  formatMoneyReverse(money, id) {
    if (!money) {
      return 0;
    }
    if (!id || id === '0') {
      id = '8';
    }
    let item = storage.get('currency')?storage.get('currency').filter(currency => id == currency.id)[0]:0;
    const decimal = item.decimals ? item.decimals : 4;
    money = multiplication(money, Math.pow(10, decimal));
    return money
  },
  //格式化显示金额,不除以10^decimal
  displayFormatMoney(money, id, decimal,flag) {
    if(!money && money!==0){
      return ""
    }
    if (!id || id === "0") {
      id = "8";
    }
    let item = storage.get("currency").filter((currency) => id == currency.id)[0];
    decimal = decimal > 0 && decimal <= 20 ? decimal : item?.decimals ? item.decimals : 4;
    money = flag?money / Math.pow(10, decimal):money;
    money = parseFloat((money + "").replace(/[^\d\.-]/g, "")).toFixed(decimal) + "";
    let d = parseFloat(money) < 0 ? Math.ceil(money) : Math.floor(money);
    let y = money.split(".")[1] || "0000";
    return d.toLocaleString("en-US") + "." + y;
  },
  //币种处理
  formatCurrency(currency_id) {
    let id = currency_id == '0' ? '8' : currency_id;
    if (process.client) {
      const currency = storage.get('currency');
      if (currency) {
        const tmp = currency.filter(v => v.id == id)[0];
        if (tmp) {
          return tmp.dcode;
        }
      } else {
        return id;
      }
    }
  },
  /**
   * 用于货币数据类型转换：带符号和千分位数据去掉货币符号和，
   * 例如：￥12,345.0000转换后为12345.0000
   * @param num 需要处理的数据
   * @returns {*} 处理后的数据
   */
  moneyDelete(num) {
    if (num && num != undefined && num != null) {
      let _num = num;
      if (_num[0] >= 0) {
        _num = _num.toString();
        _num = _num.replace(/,/gi, '');
        return _num;
      } else {
        _num = _num.slice(1);
        _num = _num.toString();
        _num = _num.replace(/,/gi, '');
        return _num;
      }
    } else {
      return num;
    }
  },
  /**
   * 时间戳到格式化时间
   * {{item.createTime|filterTimeToFormatTime('MM-DD dddd')}}
   * @param {*} time
   * @param {*} cFormat
   */
  filterTimeToFormatTime(time, cFormat) {
    if (!cFormat) {
      cFormat = 'YY/MM/DD';
    }
    if (!time || time == 0) {
      return '--';
    }
    return timestampToFormatTime(time, cFormat);
  },
  /** 格式化时间到时间戳 */
  filterFormatTimeToTimestamp(format) {
    return formatTimeToTimestamp(format);
  },
  /** 用户头像的占位图标 */
  filterUserImg(value) {
    if (value) {
      return '/rest/store/general/v3/image/' + value;
    } else {
      return require('~/common/assets/img/head.png');
    }
  },
  /** LOGO的占位图标 */
  filterLogoImg(value) {
    if (value) {
      return '/rest/store/general/v3/image/' + value;
    } else {
      return require('~/common/assets/img/default_product_img.jpeg');
    }
  },
  /** 详情展示过滤*/
  filterData(value, item, rowData = {}) {
    let data = '';
    if (item.type === 'readonly' && item.tip) return item.tip;
    if (typeof value === 'undefined' || value === '' || value === '0') return;
    switch (item.type) {
      case 'select':
      case 'selectPro':
      case 'radio':
        // 有tip字段不走过滤器。如果传了对象进来，则取对象的label指定的字段 2022-11-25 订单域-黄金龙
        if (item.tip) {
          data = Object.prototype.toString.call(value) === '[object Object]' ? value[item.label] : value;
          break;
        }
        // 如果每行的下拉选择框数据非固定，则需要根据不同配置字段从表格行中取值（合约域新增）
        if(item.isRowOption) {
          const findData = rowData[item.rowConfig.optionName]?.find(item => item.id === value);
          data = findData?.name || '';
          break;
        }
        //如果option是异步获取，那么option就一直为空，所以select最好都加tip
        item.option = item.option ? item.option : [];
        const optionSelected = item.option.find(fieldItem => fieldItem.id == value);
        data = optionSelected ? optionSelected.name : '';
        break;
      case 'obj':
        if (item.sub_id) {
          data = value[item.sub_id];
        } else {
          data = value;
        }
        break;
      case 'datetime':
        data = timestampToFormatTime(value, 'YY/MM/DD-HH:MM:SS');
        break;

      default:
        data = value;
    }

    return translateI18n(data);
  },
  /** 数字超过3位逗号格式化 */
  formatNumber(num) {
    if(!num && num!==0) return "--"
    else if (!num || isNaN(num)) return num;
    const arr = String(num).split('.');
    const str = String(arr[0]);
    const first = str
      .split('')
      .filter(n => !isNaN(n))
      .reverse()
      .reduce((acc, fn, index) => {
        const res = index % 3 === 0 ? fn + ',' + acc : fn + acc;
        return res;
      });

    const second = arr[1] ? '.' + arr[1] : '';
    const result = num < 0 ? String(num).charAt(0) + first + second : first + second;
    return result;
  },
  /** 获取文件类型图标 */
  getFileTypeIcon(file, type) {
    let icon = '';
    try {
      icon = funGetFileTypeIcon(file, type);
    } catch (error) {
      icon = require(`~/common/assets/img/file_unknown_${type}.png`);
      console.warn('未获取到正确的图标类型！', error);
    }
    return icon;
  },

  getFileTypeIconWithSuffix(ext, type) {
    ext = ext.toLowerCase();
    if (arrayContain(['jpg', 'jpeg', 'png', 'gif', 'raw'], ext)) {
      if (type == 'm') {
        return '/rest/store/general/v3/image/' + file.ipfs;
      } else {
        return require(`~/common/assets/img/file_img_${type}.png`);
      }
    } else if (arrayContain(['mp4', 'mp3', 'avi'], ext)) {
      return require(`~/common/assets/img/file_video_${type}.png`);
    } else if (arrayContain(['xlsx', 'xls', 'csv'], ext)) {
      return require(`~/common/assets/img/file_excle_${type}.png`);
    } else if (arrayContain(['doc', 'docx'], ext)) {
      return require(`~/common/assets/img/file_word_${type}.png`);
    } else if (arrayContain(['rar', 'zip'], ext)) {
      return require(`~/common/assets/img/file_zip_${type}.png`);
    } else if (ext === 'pdf') {
      return require(`~/common/assets/img/file_pdf_${type}.png`);
    } else if (ext === 'ppt' || ext === 'pptx') {
      return require(`~/common/assets/img/file_ppt_${type}.png`);
    } else if (arrayContain(['txt', 'text'], ext)) {
      return require('~/common/assets/img/file_txt_m.png');
    }

    return require(`~/common/assets/img/file_unknown_${type}.png`);
  },
  /** 使用el-upload组件时headers参数 */
  getHttpHeader() {
    let session = '';
    if (process.client) {
      session = storage.get('session_token') || storage.get('session_token', true) || '';
    }
    return {
      'X-Session-Token': session
    };
  },
  /** 时间戳转换为离现在多长时间展示 */
  getDateDiff(dateTimeStamp) {
    try {
      let result;
      dateTimeStamp < 10000000000 && (dateTimeStamp *= 1000);
      let minute = 1000 * 60;
      let hour = minute * 60;
      let day = hour * 24;
      let halfamonth = day * 15;
      let month = day * 3;
      let now = new Date().getTime();
      let diffValue = now - dateTimeStamp;
      let monthC = diffValue / month;
      let weekC = diffValue / (7 * day);
      let dayC = diffValue / day;
      let hourC = diffValue / hour;
      let minC = diffValue / minute;
      if (hourC >= 24) {
        result = timestampToFormatTime(dateTimeStamp, 'YY/MM/DD');
      } else if (hourC >= 1) {
        result = parseInt(hourC) + '小时前';
      } else if (minC >= 1) {
        result = parseInt(minC) + '分钟前';
      } else result = '刚刚发表';
      return result;
    } catch (error) {
      return '';
    }
  },
  sTransferMs(s) {
    // 秒转换为分秒
    if (!s) return '--';
    var h;
    h = Math.floor(s / 60); //计算秒
    s = s % 60; // 取得秒%60的余数，既得到秒数
    h += ''; //将变量转换为字符串
    s += '';
    h = h.length == 1 ? '0' + h : h; //如果只有一位数，前面增加一个0
    s = s.length == 1 ? '0' + s : s;
    return `${h}'${s}"`;
  },
  articleTypeFilter(val = 100, type) {
    let types = type ? type : "name"
    let articleType = {
      0: {name:'portal.quan-bu', short_name:'portal.quan', img:require("~/common/assets/img/content-default1.png")},
      100: {name:'portal.wen-zhang', short_name:'portal.wen', img:require("~/common/assets/img/content-default1.png")},
      200: {name:'portal.wen-da', short_name:'portal.da', img:require("~/common/assets/img/content-default2.png")},
      300: {name:'portal.wen-juan', short_name:'portal.ask', img:require("~/common/assets/img/content-default3.png")},
      400: {name:'portal.yao-qing', short_name:'portal.yao-q', img:require("~/common/assets/img/content-default4.png")},
      500: {name:'portal.guang-gao', short_name:'portal.guang', img:require("~/common/assets/img/content-default5.png")},
      700: {name:'portal.tu-su', short_name:'portal.tou', img:require("~/common/assets/img/content-default1.png")},
      901: {name:'portal.wen-zhang', short_name:'portal.wen', img:require("~/common/assets/img/content-default1.png")},
      902: {name:'portal.wen-zhang', short_name:'portal.wen', img:require("~/common/assets/img/content-default1.png")},
      903: {name:'portal.zhi-bo', short_name:'portal.shi-p', img:require("~/common/assets/img/content-default6.png")}
    };
    return translateI18n(articleType[val][types]);
  }
};

export function getIn(p, o) {
  return p.reduce(function(xs, x) {
    return xs && xs[x] ? xs[x] : null;
  }, o);
}
/**
 * 判断详情页是否能够编辑
 * param option {
 * 	router: 利用路由判断是否有权限，
 *  其余的是true 则可以
 * }
 * 例如：
 * this.baseInfo.option.edit = whetherDetailEdit({
			router: this.$route.fullPath,
			active: this.baseInfo.data?.active,
			pending: this.tabOption.tabMain?.account?.data?.pending !== '提交'
		})
 * @returns true/false
 */
export function whetherDetailEdit(option,type='update') {
  let count = 0;
  let i = 0;
  const urlArr = option['router'].split('/').filter(item => item);
  for (let k in option) {
    i++;
    if (k === 'router') {
      getIn(urlArr, auth) && getIn(urlArr, auth)[type] ? count++ : count--;
    } else {
      option[k] ? count++ : count--;
    }
  }
  return i === count;
}
//全局过自定义指令
const icDirectives = {
  /**
   * 界面展示权限自定义指令：v-auth
   * 作用：控制当前元素是否加载
   * 参数binding.arg:权限名称v-auth:create
   * 绑定值binding.value:当前页面路由$route.fullPath
   * 用例：<el-button v-auth:create="$route.fullPath"></el-button>
   */
  auth: {
    inserted: function(el, binding) {
      let auth = storage.get('profile') ? deepAssign(baseAuth, storage.get('profile').auth) : { ...baseAuth };
      if (!binding.value) return true;
      let p = binding.value;
      if (/\?/.test(p)) {
        p = p.split('?')[0];
      }
      const urlArr = p.split('/').filter(item => item);
      getIn(urlArr, auth) && getIn(urlArr, auth)[binding.arg] ? '' : (el.style.display = 'none');
    }
  },
  /**
   * 按钮自定义指令：v-avoidRepeat
   * 作用：防止多次点击
   * 用例：<el-button v-avoidRepeat></el-button>
   * <el-button v-avoidRepeat:value="5000"></el-button>
   */
  avoidRepeat: {
    inserted(el, binding) {
      function __avoidRepeatHandler__() {
        if (el.__clickDisabled__) return;
        el.__clickDisabled__ = true;
        el.__originalPointerEvents__ = el.style.pointerEvents;
        el.style.pointerEvents = 'none';
        setTimeout(() => {
          el.__clickDisabled__ = false;
          el.style.pointerEvents = el.__originalPointerEvents__;
        }, binding.value || 500);
      }
      el.addEventListener('click', __avoidRepeatHandler__);
      el.__avoidRepeatHandler__ = __avoidRepeatHandler__;
    },
    unbind(el) {
      el.removeEventListener('click', el.__avoidRepeatHandler__);
      delete el.__clickDisabled__;
      delete el.__originalPointerEvents__;
    }
  }
};

icUtils.install = function(Vue, options) {
  // 1. 添加全局方法或 property
  // Vue.myGlobalMethod = function () {
  //   // 逻辑...
  // }

  // 2. 添加全局资源
  // Vue.directive('my-directive', {
  //   bind (el, binding, vnode, oldVnode) {
  //     // 逻辑...
  //   }
  // })

  // 3. 注入组件选项
  // Vue.mixin({
  //   created: function () {
  //     // 逻辑...
  //   }
  // })

  Vue.prototype.$icutil = {
    /**
     * 处理 table中，pagination翻页问题
     * @param {object} paginationRes 返回的pagination
     * @param {object} paginationReq 传入的返回的pagination 即 this.pagination
     * @param {function} cb 回调fn 即getTableList
     */
     paginationDeal(paginationRes, paginationReq, cb, param) {
      const pageSize = paginationRes.page_size || paginationRes.pageSize;
      paginationReq.total = paginationRes.total;
      if (paginationReq.current !== 1) {
        let total = paginationRes.total || 0;
        if (Math.ceil(total / pageSize) < paginationReq.current) {
          paginationReq.current = 1;
          cb(param);
        }
      }
    },
    handleNotify(data, noticeList) {
      let prefix = '/store';
      let target = '_self'
      switch (data.content.notification_type) {
        case 'info_folder':
          data.content.msgUrl = `${prefix}/info/folder`;
          break;
        case 'brand_assign_pm':
          data.content.plain_text = arrToSpuHtml(JSON.parse(data.content.content), `/erp/product/brand/management?id=`, '厂牌');
          break;
        case 'spu_assign_pm':
          data.content.plain_text = arrToSpuHtml(JSON.parse(data.content.content), `/erp/product/spu/management?id=`, '产品');
          break;
        case 'business':
          let bizData = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/cart/workbench?id=${bizData.id}&tab=${bizData.tab}`;
          break;
        case 'qfr_line':
          let qfrData = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/buy/${qfrData.tab}?id=${qfrData.id}`;
          break;
        case 'biz_sales_order':
          let salesData = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/buy/${salesData.tab}?id=${salesData.id}`;
          break;
        case 'biz_purchase_order':
          let purchaseData = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/sell/${purchaseData.tab}?id=${purchaseData.id}`;
          break;
        case 'commerce_order':
          let commerceData = JSON.parse(item.content);
          item.msgUrl = `${prefix}/order/${commerceData.tab}?id=${commerceData.id}`;
          break
        case 'product':
          if (data.content.content) {
            let proData = JSON.parse(data.content.content);
            data.content.msgUrl = `/erp/product/workbench?id=${proData.id}&tab=${proData.tab}`;
          }
          break;
        case 'spu_listprice_anchor':
          if (data.content.content) {
            let proData = JSON.parse(data.content.content);
            const str = `
            【产品中心】您的品项型号：${proData.part_number} 厂牌：${proData.brand_name}，有锚定供货，请查看！
            `
            data.content.plain_text = str
            // data.content.msgUrl = `/erp/product/price/list_price?id=${proData.spu_id}&tab=${proData.tab}`;
          }
          break;
        case 'spu_listprice_anchor_cancel':
          if (data.content.content) {
            let proData = JSON.parse(data.content.content);
            const str = `
            【产品中心】您的品项型号：${proData.part_number} 厂牌：${proData.brand_name}，已被取消锚定供货，请查看！
            `
            data.content.plain_text = str
            // data.content.msgUrl = `/erp/product/price/list_price?id=${proData.spu_id}&tab=${proData.tab}`;
          }
          break;
        case 'service_import':
          if (data.content.content) {
            let {ObjectId, ImportType,ShopMemberId} = JSON.parse(data.content.content)[0];
            let tab = ''
            if(ImportType === 'spu_spu' ) {
              tab = 'spu'
            }
            else if(ImportType === 'contact_contact_person') {
              tab = 'contacts'
            }
            target = '_blank'
            if(tab === 'spu') {
              data.content.msgUrl = `/erp/product/product/brand?id=${ObjectId}&tab=${tab}&import=spu_import`;
            } else {
              if(ShopMemberId !== ObjectId) {
                data.content.msgUrl = `${prefix}/info/profile?tab=member&import=contact_import&id=${ObjectId}`;
              } else {
                data.content.msgUrl = `${prefix}/info/member?tab=${tab}&import=contact_import`;
              }

            }
          }
          break;

        case 'new_user_account':
          if (data.content.content) {
            let userData = JSON.parse(data.content.content);
            data.content.plain_text = `${userData.name}`;
            data.content.msgUrl = `/erp/account/account/management?id=${userData.id}`;
          }
          break;
        case 'account':
          let accountData = JSON.parse(data.content.content);
          if (accountData.type === 'front-shop-account') {
            data.content.msgUrl = `${prefix}/info/account_contact?tab=${accountData.tab}`;
          } else if (accountData.type === 'backend-account-management-list') {
            data.content.msgUrl = `/erp/account/account/management?id=${accountData.id}&tab=${accountData.tab}&win_type=${accountData.win_type}`;
          } else if(accountData.type === 'backend-account-bankinfo') {
            data.content.msgUrl = `/erp/account/bank/info?id=${accountData.id}&tab=account`;
          }else if(accountData.type === 'backend-account-taxinfo') {
            data.content.msgUrl=`/erp/account/invoice/info?id=${accountData.id}&tab=account`
          }
          break;
        case 'shop_apply_join':// 户主-申请加入商户待审批
          if (data.content.content) {
            let joinShopData = JSON.parse(data.content.content);
            data.content.plain_text = `${joinShopData.name}用户申请加入${joinShopData.shop_name}商户，请审批`;
            data.content.msgUrl = `${prefix}/info/profile?id=${joinShopData.shop_id}&tab=member'`;
          }
          break;
        case 'shop_apply_join_approve':// 申请用户-加入商户审批通过
          if (data.content.content) {
            let joinShopData = JSON.parse(data.content.content);
            data.content.plain_text = `您已经成功加入${joinShopData.name}商户`;
            data.content.msgUrl = `${prefix}/info/member?id=${joinShopData.id}`;
          }
          break;
        case 'shop_owner_apply_join_approve':// 户主-加入商户审批通过
          data.content.msgUrl = `${prefix}/info/profile?tab=member`;
          break;
        case 'shop_apply_join_invited':// 申请用户-申请加入商户待审批
          data.content.msgUrl = `${prefix}/user/shop`;
          break;
        case 'owner_update_member_job':// 户主-授职
          data.content.msgUrl = `${prefix}/info/profile?tab=member`;
          break;
        case 'update_member_job':// 申请用户-授职
          data.content.msgUrl = `${prefix}/info/member`;
          break;
        case 'shop_apply_join_reject':
          if (data.content.content) {
            let joinShopData = JSON.parse(data.content.content);
            data.content.plain_text = `${joinShopData.name}商户拒绝您的加入`;
          }
          break;
        case 'activity':
          if (data.content.content) {
            let activityData = JSON.parse(data.content.content);
            // 2022-04-25 更新，创建活动时origin加入了域前缀，这里需要处理存量数据和后续新增数据的域前缀判断
            const ifHasPrefix = ichubProjectList.some(item => activityData?.origin?.startsWith(`/${item.prefix}`));
            let newPrefix = ifHasPrefix ? '' : prefix;
            data.content.msgUrl = `${newPrefix}${activityData.origin}?id=${activityData.id}&activity_id=${activityData.activity_id}&tab=activity`;
          }
          break;
        case 'import':
          if (data.content.content) {
            let importData = JSON.parse(data.content.content);
            data.content.msgUrl = `${prefix}/hub/${importData.tab}?type=${importData.type}&uuid=${importData.uuid}`;
          }
          break;
        case 'service_import':
          if (data.content.content) {
            let {ObjectId, ImportType,ShopMemberId} = JSON.parse(data.content.content)[0];
            let tab = ''
            if(ImportType === 'spu_spu' ) {
              tab = 'spu'
            }
            else if(ImportType === 'contact_contact_person') {
              tab = 'contacts'
            }
            target = '_blank'
            if(tab === 'spu') {
              data.content.msgUrl = `/erp/product/product/brand?id=${ObjectId}&tab=${tab}&import=spu_import`;
            } else {
              if(ShopMemberId !== ObjectId) {
                data.content.msgUrl = `${prefix}/info/profile?tab=member&import=contact_import&id=${ObjectId}`;
              } else {
                data.content.msgUrl = `${prefix}/info/member?tab=${tab}&import=contact_import`;
              }

            }
          }
          break;
        //供货项需求页签报价
        // case 'avab_line_rfq_qfr':
        //   if (data.content.content) {
        //     //ids是满足条件的数据id,id是详情的id
        //     let avabData = JSON.parse(data.content.content);
        //     data.content.msgUrl = `${prefix}/sell/avab_line_detail/?id=${avabData.id}&ids=${avabData.ids[0]}&tab=avab_line_rfq_qfr`;
        //   }
        //   break;
        // //询价项供货页签报价
        // case 'rfq_line_avab_qfa':
        //   if (data.content.content) {
        //     let rfqData = JSON.parse(data.content.content);
        //     data.content.msgUrl = `${prefix}/buy/rfq_line_detail/?id=${rfqData.id}&ids=${rfqData.ids[0]}&tab=rfq_line_avab_qfa`;
        //   }
        //   break;
        //交易台报价
        case 'exchange_rfq':
          if (data.content.content) {
            let cartData = JSON.parse(data.content.content);
            data.content.msgUrl = `${prefix}/cart/exchange?id=${cartData.id}&ids=${cartData.ids[0]}&type=rfq&tab=exchange_rfq`;
          }
          break;
        case 'match_box_line':
          if (data.content.content) {
            let matchData = JSON.parse(data.content.content);
            if(matchData.rfq_line_id){
              // 询价项询问通知：直达采购询价项列表定位该行（批次B B1，后端批次A携带 rfq_line_id/tab）
              data.content.msgUrl = `${prefix}/buy/${matchData.tab}?id=${matchData.rfq_line_id}`;
            } else {
              const type=["rfq_line","qfr_line","sales_order_line"].includes(matchData.subject_type)?"buy":
              ["avab_line","qfa_line","purchase_order_line"].includes(matchData.subject_type)?"sell":""
              data.content.msgUrl = `${prefix}/${type}/${matchData.subject_type}?id=${matchData.subject_id}&match_id=${matchData.id}`;
              if(matchData.order_id){
                data.content.msgUrl = `${prefix}/order/sale_bill?id=${matchData.order_id}`;
              }
            }
          }
          break;
        case 'rfq_line_aggsign':// 询价项分派/撤回：落地采购工作台分派视图
          data.content.msgUrl = `${prefix}/buy/purchasing_rfq_line?view=assigned`;
          break;
        case 'avab_line':
          if (data.content.content) {
            let matchData = JSON.parse(data.content.content);
            if(matchData.id){
              data.content.msgUrl = `${prefix}/sell/avab_line?id=${matchData.id}&match_id=${matchData.id}`;
            }
          }
          break;
        case 'avab_purchase':
          if (data.content.content) {
            let matchData = JSON.parse(data.content.content);
            if(matchData.id){
              data.content.msgUrl = `${prefix}/sell/avab_line?id=${matchData.id}&match_id=${matchData.id}`;
            }
          }
          break;
        case 'sales_order_line':
          if (data.content.content) {
            let matchData = JSON.parse(data.content.content);
            if(matchData.id){
              data.content.msgUrl = `${prefix}/buy/sales_order_line?id=${matchData.id}&match_id=${matchData.id}`;
            }
          }
          break;
        case 'rfq_line':
          if (data.content.content) {
            let matchData = JSON.parse(data.content.content);
            if(matchData.id){
              data.content.msgUrl = `${prefix}/buy/rfq_line?id=${matchData.id}&match_id=${matchData.id}`;
            }
          }
          break;
        case 'purchase_order_line':
          if (data.content.content) {
            let matchData = JSON.parse(data.content.content);
            if(matchData.id){
              data.content.msgUrl = `${prefix}/sell/purchase_order_line?id=${matchData.id}&match_id=${matchData.id}`;
            }
          }
          break;
        case 'order_import':
          if (data.content.content) {
            target = '_blank'
            data.content.msgUrl =  `${prefix}/hub/history`;
          }
          break;
        case 'commerce_sales_line_item'://销售跟项
          let commerce_sales_line_item = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/order/sale_item?id=${commerce_sales_line_item.id}&tab=${commerce_sales_line_item.tab}`;
          break;
        case 'commerce_sales_order'://销售跟单
          let commerce_sales_order = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/order/sale_bill?id=${commerce_sales_order.id}`;
          break;
        case 'commerce_sales_return_item'://销售退货
          let commerce_sales_return_item = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/order/sale_return?id=${commerce_sales_return_item.id}&tab=${commerce_sales_return_item.tab}`;
          break;
        case 'commerce_purchase_line_item'://采购跟项
          let commerce_purchase_line_item = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/order/purchase_item?id=${commerce_purchase_line_item.id}&tab=${commerce_purchase_line_item.tab}`;
          break;
        case 'commerce_purchase_order'://采购跟单
          let commerce_purchase_order = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/order/purchase_bill?id=${commerce_purchase_order.id}`;
          break;
        case 'commerce_purchase_return_item'://采购退货
          let commerce_purchase_return_item = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/order/purchase_return?id=${commerce_purchase_return_item.id}&tab=${commerce_purchase_return_item.tab}`;
          break;
        case 'biz_avab_line':
          const biz_avab_line = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/cart/business_desk?id=${biz_avab_line.dashboard_id}&tab=qfa_line&id1=${biz_avab_line.id}&tab1=match&from=qa_line&pageType=BusinessDeskDetail`
          break;
        case 'biz_rfq_line':
          const biz_rfq_line = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/cart/business_desk?id=${biz_rfq_line.dashboard_id}&tab=qfr_line&id1=${biz_rfq_line.id}&tab1=match&from=qa_line&pageType=BusinessDeskDetail`
          break;
        case 'biz_sales_order_line':
          let biz_sales_order_line = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/cart/business_desk?id=${biz_sales_order_line.dashboard_id}&tab=sales_order_line&id1=${biz_sales_order_line.id}&tab1=match&from=qa_line&pageType=BusinessDeskDetail`
          break;
        case 'biz_purchase_order_line':
          let biz_purchase_order_line = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/cart/business_desk?id=${biz_purchase_order_line.dashboard_id}&tab=purchase_order_line&id1=${biz_purchase_order_line.id}&tab1=match&from=qa_line&pageType=BusinessDeskDetail`
          break;
        case 'contact-person-detail':
          let frontContactPersonDetail = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/info/contact?id=${frontContactPersonDetail.id}`
          console.log(123,data.content.msgUrl)
          break;
        case 'cms_email':
          data.content.msgUrl = `/content/work/creation?columnId=${data.content.content}`;
          break;
        case 'cfo_tax_receipt_submit_sales':
        case 'cfo_tax_receipt_return_sales':
        case 'cfo_tax_receipt_approve_sales':
        case 'cfo_tax_receipt_biz_date_sales':
          let cfo_tax_receipt = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/finance/receivable/cfo_tax_receipt?id=${cfo_tax_receipt.id}`
          break;
        case 'cfo_tax_receipt_submit_purchase':
        case 'cfo_tax_receipt_return_purchase':
        case 'cfo_tax_receipt_approve_purchase':
        case 'cfo_tax_receipt_biz_date_purchase':
          let cfo_tax_receipt_outbound = JSON.parse(data.content.content);
          data.content.msgUrl = `${prefix}/finance/payable/cfo_tax_receipt_outbound?id=${cfo_tax_receipt_outbound.id}`
          break;
      }
      if(data.content.category=='todo'){
        data.content.plain_text = data.content?.object_type_name?'【'+data.content.object_type_name+'】'+(data.content?.shop_name?'【'+data.content.shop_name+'】'+data.content.plain_text:data.content.plain_text):
          (data.content?.shop_name?'【'+data.content.shop_name+'】'+data.content.plain_text:data.content.plain_text)
      }else if(data.content.category=='notice'){
        data.content.plain_text = data.content?.shop_name?'【'+data.content.shop_name+'】'+data.content.plain_text:data.content.plain_text
      }
      Notification.info({
        title: '通知',
        dangerouslyUseHTMLString: true,
        message: data.content.msgUrl?`<a href="javascript:;">`+data.content.plain_text+'</a>':data.content.plain_text,
        offset: 60,
        onClick(){
          if(data.is_current_shop){
            const axios = process.env.PROJECT_NAME === 'content' ? Vue.prototype.$_axios : Vue.prototype.$axios
            axios.$patch('rest/store/general/v3/notifications/makeAsRead',{ids: [data.content.id]}).then(({ code, msg }) => {
              if (code === 200) {
                Message.success(msg)
                if(data.content.msgUrl){
                  if(target==="_blank") {
                    window.open(data.content.msgUrl)
                  } else {
                    location.href = data.content.msgUrl;
                  }
                }
              }
            })
          }else{
            MessageBox.confirm(`请切换到【${data.current_shop_name}】商户后继续操作`, "温馨提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(()=>{
              location.href = '/store/user/shop'
            }).catch(()=>{
              Message.info('操作已取消')
            })
          }
        }
      });
      noticeList.unshift(data.content);
    },
    handleNotifyData(list) {
      let prefix = '/store';
      return list.map(item => {
        switch (item.notification_type) {
          case 'info_folder':
            item.msgUrl = `${prefix}/info/folder`;
            break;
          case 'brand_assign_pm':
            item.plain_text = arrToSpuHtml(JSON.parse(item.content), `/erp/product/brand/management?id=`, '厂牌');
            break;
          case 'spu_assign_pm':
            item.plain_text = arrToSpuHtml(JSON.parse(item.content), `/erp/product/spu/management?id=`, '产品');
            break;
          case 'business':
            let bizData = JSON.parse(item.content);
            item.msgUrl = `${prefix}/cart/workbench?id=${bizData.id}&tab=${bizData.tab}`;
            break;
          case 'qfr_line':
            let qfrData = JSON.parse(item.content);
            item.msgUrl = `${prefix}/buy/${qfrData.tab}?id=${qfrData.id}`;
            break;
          case 'biz_sales_order':
            let salesData = JSON.parse(item.content);
            item.msgUrl = `${prefix}/buy/${salesData.tab}?id=${salesData.id}`;
            break;
          case 'biz_purchase_order':
            let purchaseData = JSON.parse(item.content);
            item.msgUrl = `${prefix}/sell/${purchaseData.tab}?id=${purchaseData.id}`;
            break
          case 'commerce_order':
            let commerceData = JSON.parse(item.content);
            item.msgUrl = `${prefix}/order/${commerceData.tab}?id=${commerceData.id}`;
            break
          case 'product':
            if (item.content) {
              let proData = JSON.parse(item.content);
              item.msgUrl = `/erp/product/workbench?id=${proData.id}&tab=${proData.tab}`;
            }
            break;
          case 'new_user_account':
            if (item.content) {
              let userData = JSON.parse(item.content);
              item.plain_text = `${userData.name}`;
              item.msgUrl = `/erp/account/account/management?id=${userData.id}`;
            }
            break;
          case 'account':
            if (item.content) {
              let accountData = JSON.parse(item.content);
              if (accountData.type === 'front-shop-account') {
                item.msgUrl = `${prefix}/info/account_contact?tab=${accountData.tab}`;
              } else if (accountData.type === 'backend-account-management-list') {
                item.msgUrl = `/erp/account/account/management?id=${accountData.id}&tab=${accountData.tab}&win_type=${accountData.win_type}`;
              } else if(accountData.type === 'backend-account-bankinfo') {
                item.msgUrl=`/erp/account/bank/info?id=${accountData.id}&tab=account`
              }else if(accountData.type === 'backend-account-taxinfo') {
                item.msgUrl=`/erp/account/invoice/info?id=${accountData.id}&tab=account`
              }
              break;
            }
          case 'shop_apply_join':// 户主-申请加入商户待审批
            if (item.content) {
              let joinShopData = JSON.parse(item.content);
              item.plain_text = `${joinShopData.name}用户申请加入${joinShopData.shop_name}商户，请审批`;
              item.msgUrl = `${prefix}/info/profile?id=${joinShopData.shop_id}&tab=member`;
            }
            break;
          case 'shop_apply_join_approve':// 申请用户-加入商户审批通过
            if (item.content) {
              let joinShopData = JSON.parse(item.content);
              item.plain_text = `您已经成功加入${joinShopData.name}商户`;
              item.msgUrl = `${prefix}/info/member?id=${joinShopData.id}`;
            }
            break;
          case 'shop_owner_apply_join_approve':// 户主-加入商户审批通过
            item.msgUrl = `${prefix}/info/profile?tab=member`;
            break;
          case 'shop_apply_join_invited':// 申请用户-申请加入商户待审批
            item.msgUrl = `${prefix}/user/shop`;
            break;
          case 'owner_update_member_job':// 户主-授职
            item.msgUrl = `${prefix}/info/profile?tab=member`;
            break;
          case 'update_member_job':// 申请用户-授职
            item.msgUrl = `${prefix}/info/member`;
            break;
          case 'shop_apply_join_reject':
            if (item.content) {
              let joinShopData = JSON.parse(item.content);
              item.plain_text = `${joinShopData.name}商户拒绝您的加入`;
            }
            break;
          case 'activity':
            if (item.content) {
              let activityData = JSON.parse(item.content);
              // 2022-04-25 更新，创建活动时origin加入了域前缀，这里需要处理存量数据和后续新增数据的域前缀判断
              const ifHasPrefix = ichubProjectList.some(item => activityData?.origin?.startsWith(`/${item.prefix}`));
              let newPrefix = ifHasPrefix ? '' : prefix;
              item.msgUrl = `${newPrefix}${activityData.origin}?id=${activityData.id}&activity_id=${activityData.activity_id}&tab=activity`;
            }
            break;
          case 'import':
            if (item.content) {
              let importData = JSON.parse(item.content);
              item.msgUrl = `${prefix}/hub/${importData.tab}?type=${importData.type}&uuid=${importData.uuid}`;
            }
            break;
          case 'service_import':
            if (item.content) {
              if(/ImportType/.test(item.content)) {
                let {ObjectId, ImportType,ShopMemberId} = JSON.parse(item.content)[0]
                let tab = ''
                if(ImportType === 'spu_spu' ) {
                  tab = 'spu'
                }
                else if(ImportType === 'contact_contact_person') {
                  tab = 'contacts'
                }
                if(tab === 'spu') {
                  item.msgUrl = `/erp/product/product/brand?id=${ObjectId}&tab=${tab}&import=spu_import`;
                } else {
                  if(ShopMemberId !== ObjectId) {
                    item.msgUrl = `${prefix}/info/profile?tab=member&import=contact_import&id=${ObjectId}`;
                  } else {
                    item.msgUrl = `${prefix}/info/member?tab=${tab}&import=contact_import`;
                  }
                }
              }
            }
            break;
          //供货项需求页签报价
          // case 'avab_line_rfq_qfr':
          //   if (item.content) {
          //     //ids是满足条件的数据id,id是详情的id
          //     let avabData = JSON.parse(item.content);
          //     item.msgUrl = `${prefix}/sell/avab_line/?id=${avabData.id}&ids=${avabData.ids[0]}&tab=avab_line_rfq_qfr`;
          //   }
          //   break;
          // //询价项供货页签报价
          // case 'rfq_line_avab_qfa':
          //   if (item.content) {
          //     let rfqData = JSON.parse(item.content);
          //     item.msgUrl = `${prefix}/buy/rfq_line/?id=${rfqData.id}&ids=${rfqData.ids[0]}&tab=rfq_line_avab_qfa`;
          //   }
          //   break;
          //交易台报价
          case 'exchange_rfq':
            if (item.content) {
              let cartData = JSON.parse(item.content);
              item.msgUrl = `${prefix}/cart/exchange?id=${cartData.id}&ids=${cartData.ids[0]}&type=rfq&tab=exchange_rfq`;
            }
            break;
          case 'match_box_line':
            if (item.content) {
              let matchData = JSON.parse(item.content);
              if(matchData.rfq_line_id){
                // 询价项询问通知：直达采购询价项列表定位该行（批次B B1，后端批次A携带 rfq_line_id/tab）
                item.msgUrl = `${prefix}/buy/${matchData.tab}?id=${matchData.rfq_line_id}`;
              } else {
                const type=["rfq_line","qfr_line","sales_order_line"].includes(matchData.subject_type)?"buy":
                ["avab_line","qfa_line","purchase_order_line"].includes(matchData.subject_type)?"sell":""
                item.msgUrl = `${prefix}/${type}/${matchData.subject_type}?id=${matchData.subject_id}&match_id=${matchData.id}`;
                if(matchData.order_id){
                  item.msgUrl = `${prefix}/order/sale_bill?id=${matchData.order_id}`;
                }
              }
            }
            break;
          case 'rfq_line_aggsign':// 询价项分派/撤回：落地采购工作台分派视图
            item.msgUrl = `${prefix}/buy/purchasing_rfq_line?view=assigned`;
            break;
          case 'avab_line':
            if (item.content) {
              let {id} = JSON.parse(item.content);
              item.msgUrl = `${prefix}/sell/avab_line?id=${id}&match_id=${id}`;
            }
            break;
          case 'avab_purchase':
            if (item.content) {
              let {id} = JSON.parse(item.content);
              item.msgUrl = `${prefix}/sell/avab_line?id=${id}&match_id=${id}`;
            }
            break;
          case 'rfq_line':
            if (item.content) {
              let {id} = JSON.parse(item.content);
              item.msgUrl = `${prefix}/buy/rfq_line?id=${id}&match_id=${id}`;
            }
            break;
          case 'sales_order_line':
            if (item.content) {
              let {id} = JSON.parse(item.content);
              item.msgUrl = `${prefix}/buy/sales_order_line?id=${id}&match_id=${id}`;
            }
            break;
          case 'purchase_order_line':
            if (item.content) {
              let {id} = JSON.parse(item.content);
              item.msgUrl = `${prefix}/sell/purchase_order_line?id=${id}&match_id=${id}`;
            }
            break;
          case 'order_import':
            if (item.content) {
              item.msgUrl = `${prefix}/hub/history`;
            }
            break;
          case 'spu_listprice_anchor':
            let proData = JSON.parse(item.content);
            const str = `
            您的品项型号：${proData.part_number} 厂牌：${proData.brand_name}，有锚定供货，请查看！
            `
            item.plain_text = str
            // data.is_current_shop = false
            break;
          case 'spu_listprice_anchor_cancel':
            let proData1 = JSON.parse(item.content);
            const str1= `
            您的品项型号：${proData1.part_number} 厂牌：${proData1.brand_name}，已被取消锚定供货，请查看！
            `
            item.plain_text = str1
            // data.is_current_shop = false
            break;
          case 'commerce_sales_line_item'://销售跟项
            let commerce_sales_line_item = JSON.parse(item.content);
            item.msgUrl = `${prefix}/order/sale_item?id=${commerce_sales_line_item.id}&tab=${commerce_sales_line_item.tab}`;
            break;
          case 'commerce_sales_order'://销售跟单
            let commerce_sales_order = JSON.parse(item.content);
            item.msgUrl = `${prefix}/order/sale_bill?id=${commerce_sales_order.id}`;
            break;
          case 'commerce_sales_return_item'://销售退货
            let commerce_sales_return_item = JSON.parse(item.content);
            item.msgUrl = `${prefix}/order/sale_return?id=${commerce_sales_return_item.id}&tab=${commerce_sales_return_item.tab}`;
            break;
          case 'commerce_purchase_line_item'://采购跟项
            let commerce_purchase_line_item = JSON.parse(item.content);
            item.msgUrl = `${prefix}/order/purchase_item?id=${commerce_purchase_line_item.id}&tab=${commerce_purchase_line_item.tab}`;
            break;
          case 'commerce_purchase_order'://采购跟单
            let commerce_purchase_order = JSON.parse(item.content);
            item.msgUrl = `${prefix}/order/purchase_bill?id=${commerce_purchase_order.id}`;
            break;
          case 'commerce_purchase_return_item'://采购退货
            let commerce_purchase_return_item = JSON.parse(item.content);
            item.msgUrl = `${prefix}/order/purchase_return?id=${commerce_purchase_return_item.id}&tab=${commerce_purchase_return_item.tab}`;
            break;
          case 'biz_avab_line':
            const biz_avab_line = JSON.parse(item.content);
            item.msgUrl = `${prefix}/cart/business_desk?id=${biz_avab_line.dashboard_id}&tab=qfa_line&id1=${biz_avab_line.id}&tab1=match&from=qa_line&pageType=BusinessDeskDetail`
            break;
          case 'biz_rfq_line':
            const biz_rfq_line = JSON.parse(item.content);
            item.msgUrl = `${prefix}/cart/business_desk?id=${biz_rfq_line.dashboard_id}&tab=qfr_line&id1=${biz_rfq_line.id}&tab1=match&from=qa_line&pageType=BusinessDeskDetail`
            break;
          case 'biz_sales_order_line':
            let biz_sales_order_lines = JSON.parse(item.content);
            item.msgUrl = `${prefix}/cart/business_desk?id=${biz_sales_order_lines.dashboard_id}&tab=sales_order_line&id1=${biz_sales_order_lines.id}&tab1=match&from=qa_line&pageType=BusinessDeskDetail`
            break;
          case 'biz_purchase_order_line':
            let biz_purchase_order_line = JSON.parse(item.content);
            item.msgUrl  = `${prefix}/cart/business_desk?id=${biz_purchase_order_line.dashboard_id}&tab=purchase_order_line&id1=${biz_purchase_order_line.id}&tab1=match&from=qa_line&pageType=BusinessDeskDetail`
            break;
          case 'contact-person-detail':
            let frontContactPersonDetail = JSON.parse(item.content);
            item.msgUrl = `${prefix}/info/contact?id=${frontContactPersonDetail.id}`
            break;
          case 'cms_email':
            item.msgUrl = `/content/work/creation?columnId=${item.content}`;
            break;
          case 'cfo_tax_receipt_submit_sales':
          case 'cfo_tax_receipt_return_sales':
          case 'cfo_tax_receipt_approve_sales':
          case 'cfo_tax_receipt_biz_date_sales':
            let cfo_tax_receipt = JSON.parse(item.content);
            item.msgUrl = `${prefix}/finance/receivable/cfo_tax_receipt?id=${cfo_tax_receipt.id}`
            break;
          case 'cfo_tax_receipt_submit_purchase':
          case 'cfo_tax_receipt_return_purchase':
          case 'cfo_tax_receipt_approve_purchase':
          case 'cfo_tax_receipt_biz_date_purchase':
            let cfo_tax_receipt_outbound = JSON.parse(item.content);
            item.msgUrl = `${prefix}/finance/payable/cfo_tax_receipt_outbound?id=${cfo_tax_receipt_outbound.id}`
            break;
          case "workflow":
          case "chat":
            let content = JSON.parse(item.content);
            if (content.type === 40) {
              item.plain_text = `您有一条新的聊天信息:[卡片]`;
            } else if (content.type === 30) {
              item.plain_text = '您有一条新的聊天信息:[附件]';
            } else if (content.type === 20) {
              item.plain_text = '您有一条新的聊天信息:[图片]';
            }
            item.msgUrl = "#";
            break;
        }
        if(item.category=='todo'){
          item.plain_text = item?.object_type_name?'【'+item.object_type_name+'】'+(item?.shop_name?'【'+item.shop_name+'】'+item.plain_text:item.plain_text):
            (item?.shop_name?'【'+item.shop_name+'】'+item.plain_text:item.plain_text)
        }else if(item.category=='notice'){
          item.plain_text = item?.shop_name?'【'+item.shop_name+'】'+item.plain_text:item.plain_text
        }
        return item;
      });
    },
    // base64 转换机
    getBase64(file) {
      return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        let imgResult = '';
        reader.readAsDataURL(file);
        reader.onload = function() {
          // imgResult = reader.result;
          imgResult = reader.result.split(';base64,')[1]; // 剪掉头部
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(imgResult);
        };
      });
    },
    // 计算 0 的个数
    NumberOf0(num) {
      return Number((num + '').split('0').length - 1);
    },
    // 去0取整 1.20000 => 1.2  12.00000 => 12
    cutZero(old) {
      //拷贝一份 返回去掉零的新串
      let newstr = old;
      //循环变量 小数部分长度
      var leng = old.length - old.indexOf('.') - 1;
      //判断是否有效数
      if (old.indexOf('.') > -1) {
        //循环小数部分
        for (let i = leng; i > 0; i--) {
          //如果newstr末尾有0
          if (newstr.lastIndexOf('0') > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
            var k = newstr.lastIndexOf('0');
            //如果小数点后只有一个0 去掉小数点
            if (newstr.charAt(k - 1) == '.') {
              return newstr.substring(0, k - 1);
            } else {
              //否则 去掉一个0
              newstr = newstr.substring(0, k);
            }
          } else {
            //如果末尾没有0
            return newstr;
          }
        }
      }
      return old;
    },
    // 此方法来自 openbazaar/芯链商城
    // Converts an amount from one currency to another based on exchange rate data.
    // 传入源币种金额、源币种、目标币种、传入的金额是个数，根据汇率计算出目标币种金额
    // fromCur || toCur 的结构 {name:"EOS",rate:888}
    convertCurrency(amount, fromCur, toCur, tokensInfo, numFlag) {
      if (typeof amount !== 'number') {
        throw new Error('Please provide an amount as a number');
      }
      if (typeof fromCur !== 'string') {
        throw new Error('Please provide a fromCur as a string');
      }
      if (typeof toCur !== 'string') {
        throw new Error('Please provide a toCur as a string');
      }

      let fromCurObj = tokensInfo.find(n => n.name === fromCur);
      let toCurObj = tokensInfo.find(n => n.name === toCur);

      if (!fromCurObj) {
        throw new Error('不支持的源币种类型!');
      }

      if (!toCurObj) {
        throw new Error('不支持的目标币种类型!');
      }

      const fromRate = fromCurObj.exchangeRate;
      const toRate = toCurObj.exchangeRate;
      const fromDivisibility = fromCurObj.divisibility;

      let amountTmp = 0;
      if (numFlag) {
        amountTmp = amount;
      } else {
        amountTmp = amount / fromDivisibility;
      }

      if (fromCur === toCur) {
        return Number(amountTmp).toFixed(iccoins[toCur].divNum);
      }

      let finalAmount = Number((amountTmp / fromRate) * toRate).toFixed(iccoins[toCur].divNum);
      return this.cutZero(finalAmount); // 区别:去零返回降低性能 - 不去展示时很多0
    },
    // 获取展示价格 价格数字除以精度
    getDisplayPrice(amount, code) {
      const iccoins = {
        CNY: {
          code: 'CNY',
          currencyType: 'fiat',
          divisibility: 1000000,
          divNum: 6,
          name: 'CNY'
        },
        BTC: {
          code: 'BTC',
          currencyType: 'fiat',
          divisibility: 100000000,
          divNum: 8,
          name: 'BTC'
        },
        ICC: {
          code: 'ICC',
          currencyType: 'crypto',
          divisibility: 100000000,
          divNum: 8,
          name: 'ICC'
        }
      };
      return amount / iccoins[code].divisibility;
    },
    // 创建唯一的字符串
    createUniqueString() {
      const timestamp = +new Date() + '';
      const randomNum = parseInt((1 + Math.random()) * 65536) + '';
      return (+(randomNum + timestamp)).toString(32);
    },
    /**
     * 数字存储大小格式化
     * @param {number} num 存储大小 单位：Byte
     * @param {number} digits 保留几位小数
     * @return {string} 2MB
     */
    toStorage(num, digits) {
      digits = digits || 2;
      if (num < 1024) {
        return num + 'B';
      }
      num = (num * 1000) / 1024;
      const si = [
        { value: 1e18, symbol: 'E' },
        { value: 1e15, symbol: 'P' },
        { value: 1e12, symbol: 'T' },
        { value: 1e9, symbol: 'G' },
        { value: 1e6, symbol: 'M' },
        { value: 1e3, symbol: 'K' }
      ];
      for (let i = 0; i < si.length; i++) {
        if (num >= si[i].value) {
          return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol + 'B';
        }
      }
    },
    /**
     * 图片上传
     * @param {file} file el-upload文件对象
     * @param {number} size 限制的文件大小(kb) 默认10M
     */
    validImgUpload(file, size) {
      size = +size || 10240;
      const isSizeOut = file.size / 1024 > size;
      if (isSizeOut) {
        Message.error('上传图片大小不能超过' + toStorage(size * 1024));
      }
      return !isSizeOut;
    },
    /**
     * 可编辑表格权限处理
     * @param operable 配置权限
     * @return {Object} {}
     */
    editTableAuth(operable,url){
      if (process.client) {
        let btnMap = {
            inactive: "close",
            active: "open",
            add: "insert",
            edit: "update",
          },
          auth = storage.get('profile') ? deepAssign(baseAuth, storage.get('profile').auth) : {...baseAuth},
          current = {},
          p = url;
        if (/\?/.test(p)) {
          p = p.split('?')[0];
        }
        const urlArr = p.split('/').filter(item => item);
        for (let btn in operable) {
          if (btn != "buttons") {
            getIn(urlArr, auth) && getIn(urlArr, auth)[btnMap[btn] || btn] ? "" : delete operable[btnMap[btn] || btn];
          } else {
            operable.buttons = operable.buttons.filter(item => getIn(urlArr, auth) && getIn(urlArr, auth)[item.action])
          }
        }
        return operable
      }
    }
  };
  //添加全局过滤器
  for (let key in icFilters) {
    Vue.filter(key, icFilters[key]);
  }
  //添加全局自定义指令
  for (let key in icDirectives) {
    Vue.directive(key, icDirectives[key]);
  }
};
export { icFilters };
Vue.use(icUtils);
